export const USER_REQUIREMENTS_PAGE_SIZE = '50';
